import React from "react";
import "./SectorsSection.css";

const DeepCleaningSTrustSection = () => {
  const sectors = [
     "Corporate Offices",
  "Industrial Facilities",
  "Manufacturing Plants",
  "Hospitals & Clinics",
  "Educational Institutions",
  "Retail Stores",
  "Hotels & Restaurants",
  "Warehouses",
  "Residential Complexes",
  "Commercial Buildings",
  "Government Offices",
  "Places of Worship"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DeepCleaningSTrustSection;
